"use strict";

import angular from "angular";
import _ from "lodash";

import Colors from "/style-dictionary/properties/color/base.json";

export class ColorService {
    constructor() {
        this.colors = Colors.color;
    }

    backgroundColor = (className) => {
        const classes = {
            positive: "bg-positive",
            negative: "bg-negative",
            error: "bg-inconsistency",
            warning: "bg-warning",
            neutro: "bg-neutro",
            inconsistency: "bg-inconsistency",
            "positive-linear": "bg-positive-linear",
            "negative-linear": "bg-negative-linear",
            "error-linear": "bg-error-linear",
            "warning-linear": "bg-warning-linear",
            "neutro-linear": "bg-neutro-linear",
            "basic-linear": "basic-linear",
            "inconsistency-linear": "bg-inconsistency-linear"
        };
        return classes[className];
    };

    backgroundImage = (backgroundColor) => {
        const images = {
            "bg-positive": "bg-image-cyan",
            "bg-negative": "bg-image-purple",
            "bg-neutro": "bg-image-magenta",
            "bg-error": "bg-image-error",
            "bg-warning": "bg-image-warning"
        };

        return images[backgroundColor];
    };

    /**
     * Identify a color by your pathName in json
     * @public
     * @param {String} path
     * @return {String} Value of path
     */
    colorByPath(pathName) {
        return _.get(this.colors, `${pathName}.value`);
    }
}
angular.module("nucont.shared").service("ColorService", [ColorService]);
